
    import {Component, Prop, Vue} from 'vue-property-decorator'

    @Component
    export default class LoginPreview extends Vue {
        @Prop({required: true}) image!: string
        @Prop({required: true}) titleText!: Array<string>
        @Prop({required: true}) descriptionText!: string

        get imageStyle() {
            return {
                backgroundImage: `url(${this.image})`
            }
        }
    }
